import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayoutV2.vue";
import NotFound from "@/views/NotFoundPage.vue";

import authenticate from "../auth/authenticate";

const routes = [
  {
    path: "/",
    redirect: "dashboard",
    component: DashboardLayout,
    beforeEnter: authenticate,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/HomeDashboard.vue"),
      },
      {
        path: "/catalogos",
        name: "catalogos",
        component: () => import("../views/Catalogos"),
        children: [
          {
            path: "sucursales",
            name: "catalogo sucursales",
            component: () => import("../views/Catalogos/Sucursales.vue"),
          },
          {
            path: "sucursales/:id?",
            name: "editar sucursal",
            component: () => import("../views/Catalogos/SucursalesCrud.vue"),
          },
          {
            path: "/catalogos/categorias",
            name: "catalogo categorias",
            component: () => import("../views/Catalogos/Categorias.vue"),
          },
          {
            path: "/catalogos/productos",
            name: "catalogo productos",
            component: () => import("../views/Catalogos/Productos.vue"),
          },
          {
            path: "/catalogos/Formulas",
            name: "catalogo formulas",
            component: () => import("../views/Catalogos/Formulas.vue"),
          },
          {
            path: "/catalogos/Empleados",
            name: "catalogo empleados",
            component: () => import("../views/Catalogos/Empleados.vue"),
          },
          {
            path: "/catalogos/Proveedores",
            name: "catalogo proveedores",
            component: () => import("../views/Catalogos/Proveedores.vue"),
          },
        ],
      },
      {
        path: "/facturacion",
        component: () => import("../views/Facturacion/index.vue"),
        children: [
          {
            path: "/",
            name: "Menu Facturación",
            component: () => import("../views/Facturacion/Menu.vue"),
          },
          {
            path: "factura-sucursal",
            name: "Factura Sucursal",
            component: () => import("../views/Facturacion/FacturaSucursal.vue"),
          },
          {
            path: "factura-global",
            name: "Factura Global",
            component: () => import("../views/Facturacion/FacturaGlobal.vue"),
          },
          {
            path: "archivo",
            name: "Archivo Facturas (CFDI v4.0)",
            component: () => import("../views/Facturacion/FacturaArchivo.vue"),
          },
          {
            path: "buscador-tickets",
            name: "Buscador Tickets",
            component: () => import("../views/Facturacion/BuscadorTickets.vue"),
          },
        ],
      },
      {
        path: "/facturacionv2",
        component: () => import("../views/Facturacion/index.vue"),
        children: [
          {
            path: "/",
            name: "Menu Facturación",
            redirect: "facturacionv2-facturas",
            // component: () => import("../views/FacturacionV2/Menu.vue"),
          },
          {
            path: "facturas",
            name: "facturacionv2-facturas",
            component: () => import("../views/FacturacionV2/Facturas.vue"),
          },
          // {
          //   path: "factura-global",
          //   name: "Factura Global",
          //   component: () => import("../views/Facturacion/FacturaGlobal.vue"),
          // },
          // {
          //   path: "buscador-tickets",
          //   name: "Buscador Tickets",
          //   component: () => import("../views/Facturacion/BuscadorTickets.vue"),
          // },
        ],
      },
      {
        path: "/PAC",
        name: "Proveedor Autorizado de Certificación",
        component: () => import("../views/PAC/index.vue"),
        children: [
          {
            path: "sellos",
            name: "PAC Catalogo Sellos",
            component: () => import("../views/PAC/Sellos.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    redirect: "albaranes",
    component: DashboardLayout,
    beforeEnter: authenticate,
    children: [
      {
        path: "/albaranes/historico",
        name: "Lista de Albaranes",
        component: () => import("../views/Albaranes/List.vue"),
      },
      {
        path: "/albaranes/clientes",
        name: "Catalogo Clientes",
        component: () => import("../views/Albaranes/Clientes.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "configuracion",
    component: DashboardLayout,
    beforeEnter: authenticate,
    children: [
      {
        path: "/configuracion/usuarios",
        name: "catalogo de usuarios",
        component: () => import("../views/Configuracion/Usuarios.vue"),
      },
      // {
      //   path: "/configuracion/perfiles",
      //   name: "catalogo de perfiles",
      //   component: () => import("../views/Configuracion/Perfiles.vue"),
      // },
      // {
      //   path: "/configuracion/empresa",
      //   name: "configuración empresa",
      //   component: () => import("../views/Configuracion/EmpresaCrud.vue"),
      // },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Pages/Login.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () => import("../views/Pages/Register.vue"),
      },
      {
        path: "/logout",
        name: "logout",
        component: {
          beforeRouteEnter(to, from, next) {
            console.log({ from });
            const destination = {
              path: "/login",
              query: from.query,
              params: from.params,
            };
            if (!from) {
              console.log("no from");
            }
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            // store.dispatch("TOGGLE_MODAL");
            next(destination);
          },
        },
        beforeEnter: authenticate,
      },
      {
        path: "/facturar",
        name: "facturar",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../views/Facturacion/ClienteFacturar.vue"),
      },
      {
        path: "/home",
        name: "home",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../views/Home.vue"),
      },
      {
        path: "/descargar-cfdi",
        name: "Descargar CFDI",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import("../views/Facturacion/ClienteDescargarCfdi.vue"),
      },
      { path: "*", component: NotFound },
    ],
  },
];

export default routes;
